import styles from "@/styles/Form.module.scss";
import classnames from "classnames";
import { useCallback, useState } from "react";
import { useController } from "react-hook-form";
import ErrorMessage from "./ErrorMessage";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export default function MultiLevelMultipleCheckboxField(_ref) {
  let {
    options,
    control,
    name,
    error,
    title,
    help,
    required,
    row,
    selectedQuestionValues = () => {},
    subTitle,
    defaultValue = [],
    visible
  } = _ref;
  const {
    field
  } = useController({
    control,
    name,
    defaultValue
  });
  const {
    0: value,
    1: setValue
  } = useState(defaultValue);
  const handleChange = useCallback(e => {
    const newValue = (() => {
      if (e.target.checked) {
        return [...value, e.target.value];
      } else {
        return value.filter(v => v !== e.target.value);
      }
    })();
    field.onChange(newValue);
    setValue(newValue);
    if (typeof selectedQuestionValues === "function") {
      selectedQuestionValues(newValue);
    }
  }, [value, field, selectedQuestionValues]);
  return /*#__PURE__*/_jsxs("fieldset", {
    className: styles.questionInputField,
    style: visible ? {} : {
      display: "none"
    },
    children: [title && /*#__PURE__*/_jsxs("legend", {
      className: classnames(styles.formTitle, {
        [styles.required]: required
      }),
      children: [subTitle, ".", title]
    }), help && /*#__PURE__*/_jsx("span", {
      className: `${styles.help} ${styles.small}`,
      children: help
    }), /*#__PURE__*/_jsx("div", {
      className: classnames(styles.multipleCheckbox, {
        [styles.row]: row
      }),
      children: options.map((option, index) => /*#__PURE__*/_jsxs("div", {
        className: classnames(styles.checkbox),
        children: [/*#__PURE__*/_jsx("input", {
          id: `checkbox-${name}-${index}`,
          type: "checkbox",
          value: option.value,
          onChange: handleChange,
          onBlur: field.onBlur
        }), /*#__PURE__*/_jsx("label", {
          htmlFor: `checkbox-${name}-${index}`,
          className: `${styles.label} ${styles.small} `,
          tabIndex: "0",
          onBlur: field.onBlur,
          children: /*#__PURE__*/_jsx("span", {
            children: option.label
          })
        })]
      }, `checkbox-${name}-${index}`))
    }), error && /*#__PURE__*/_jsx(ErrorMessage, {
      msg: error
    })]
  });
}